export type BrowserThirdPartyCookiesHintId =
  | 'chrome'
  | 'firefox'
  | 'safari'
  | 'edge'
  | 'other';

/** UA minimal pour choisir un texte d’aide court (pas du fingerprinting). */
export function getBrowserThirdPartyCookiesHintIdFromUserAgent(
  ua: string
): BrowserThirdPartyCookiesHintId {
  if (/Edg\//.test(ua)) return 'edge';
  if (/Firefox\//.test(ua)) return 'firefox';
  if (/Chrome\//.test(ua) || /CriOS/.test(ua)) return 'chrome';
  if (/Safari\//.test(ua) && !/Chrome\//.test(ua) && !/CriOS/.test(ua)) {
    return 'safari';
  }
  return 'other';
}

export function getBrowserThirdPartyCookiesHintId(): BrowserThirdPartyCookiesHintId {
  if (typeof navigator === 'undefined') return 'other';
  return getBrowserThirdPartyCookiesHintIdFromUserAgent(navigator.userAgent);
}

export function getBrowserVendorHelpUrl(
  id: BrowserThirdPartyCookiesHintId
): string | null {
  switch (id) {
    case 'chrome':
      return 'https://support.google.com/chrome/answer/95647';
    case 'firefox':
      return 'https://support.mozilla.org/kb/third-party-cookies-firefox-tracking-protection';
    case 'safari':
      return 'https://support.apple.com/guide/safari/prevent-cross-site-tracking-sfri40732/mac';
    case 'edge':
      return 'https://support.microsoft.com/en-us/windows/manage-cookies-in-microsoft-edge-view-allow-block-delete-and-use-168dab11-0753-043d-7c16-ede5947fc64d';
    default:
      return null;
  }
}
